import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { BeperkingIcon } from "../../atoms/icons/BeperkingIcon";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    disabilityConfirmed?: boolean | null;
    disabilitySuspected?: boolean | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string | null>, 'value'>;
export const Beperking = (props: AllProps) => {
    const { t } = useTranslation('client');
    
    const formatDisabilityStatus = () => {
        if (props.disabilityConfirmed) return t('disabilityStatusConfirmed', );
        if (props.disabilitySuspected) return t('disabilityStatusSuspected', );
        return t('disabilityStatusNone', );
    };

    return (<Caption {...props} caption={props.label || t('disabilityStatus', 'Beperking Status')} icon={<BeperkingIcon />}>
        {formatDisabilityStatus()}
    </Caption>)
}

